import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";

@Component({
  selector: 'app-important-psicologia',
  standalone: true,
  imports: [
    NgForOf
  ],
  templateUrl: './important-psicologia.component.html',
  styleUrl: './important-psicologia.component.css'
})
export class ImportantPsicologiaComponent {
  listItems = [
    {
      texto: "Mejora el bienestar emocional de los colaboradores.",
    },
    {
      texto: "Previene el agotamiento, la depresión y otras afecciones mentales."
    },
    {
      texto: "Fomenta un ambiente laboral saludable y productivo."
    },
    {
      texto: "Reduce el ausentismo y mejora el rendimiento laboral."
    }
  ]
}
